const map = {
	"./Attendance Management 1.png": 73563,
	"./Block Chain 1.png": 35089,
	"./Digital Noticeboard 1.png": 53509,
	"./Domain Customization 1.png": 94876,
	"./Employee Management 1.png": 11808,
	"./Leave Management 1.png": 14493,
	"./Notification Center 1.png": 46897,
	"./Payroll Management 1.png": 97515,
	"./Shift Management 1.png": 35622,
	"./Tax Management 1.png": 82811
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48132;